<avd-page-title
    title="Getting started with icons"
    imgSrc="./assets/images/Component-Icons-Getting-Started-128x82-v2d.png"
></avd-page-title>

<p>
    Follow this step-by-step guide to start using UILab UX icon sprites in
    Angular applications.
</p>

<h2>Step 1: Install sprites</h2>
<p>
    Install the prebuilt sprite package to use filled, outlined, and grayscale
    icon symbol sheets.
</p>
<pre><code [highlight]="installCommand" [language]="'bash'"></code></pre>

<h2>Step 2: Add sprite files to app assets</h2>
<p>
    Copy sprite files into your application build output by adding assets
    entries in angular.json.
</p>
<pre><code [highlight]="assetsSnippet" [language]="'json'"></code></pre>

<h2>Step 3: Register sprite sheets</h2>
<p>
    Register the preferred sprites-styles icon sheets in your Angular bootstrap
    setup.
</p>

<uilab-mat-tab-group animationDuration="0ms">
    <uilab-mat-tab label="Standalone">
        <pre><code [highlight]="registerTabs[0].code" [language]="'typescript'"></code></pre>
    </uilab-mat-tab>
    <uilab-mat-tab label="NgModule">
        <pre><code [highlight]="registerTabs[1].code" [language]="'typescript'"></code></pre>
    </uilab-mat-tab>
</uilab-mat-tab-group>

<h2>Step 4: Use icon symbol ids</h2>
<p> Use namespace and symbol-id in svgIcon when rendering icons. </p>
<pre><code [highlight]="usageSnippet" [language]="'html'"></code></pre>

<h2>Step 5: Next step</h2>
<p>
    After setup, continue with the
    <a [routerLink]="['/build', 'foundations', 'iconography', 'system-icons']"
        >System icons</a
    >
    gallery.
</p>
